<template>
  <div class="industrydata">
    <div class="industry">
      <h3>行业最近数据</h3>
      <a href="https://hbba.sacinfo.org.cn/" target="_blank">更多</a>
    </div>
    <table class="tabledata">
      <thead>
        <tr>
          <th width="200">标准号</th>
          <th width="400">标准名称</th>
          <th width="400">行业领域</th>
          <th width="200"> 备案日期</th>
        </tr>
      </thead>
    </table>
    <div class="wrapper">
      <div class="content">
        <ul>
          <li v-for="(item,index) in list" :key="index">
            <span class="one">{{item.code}}</span>
            <span class="select">{{item.chName}}</span>
            <span class="size">{{ item.industry }}</span>
            <span class="last">{{ item.recordDate | datefilter }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getSacInfo } from '@/request/sacinfo';
import BScroll from 'better-scroll';
export default {
  name: "IndustryData",
  data() {
    return {
      list: [],
      bscroll: null,
      current: 1
    }
  },
  filters: {
    datefilter(value) {
      let date = new Date(value);
      return date.getFullYear() + "-" + ("0" + (date.getMonth()+1)).slice(-2)  + "-" + ("0" + date.getDate()).slice(-2);
    }
  },
  created() {
    this.getSacInfo();
  },
  mounted() {
    this.bscroll = this.initBScroll();
    this.flag = 0;
    this.bscroll.on('scroll', (data) => {
      if (data.y < -4220 && this.flag == 0) {
        this.flag = 1;
        this.bscroll.stop();
        this.bscroll.y = 0;
        this.bscroll.refresh();
      }
      if (data.y >= -2 && this.flag == 1) {
        this.changeBScroll();
        this.flag = 0;
      }
    })
  },
  methods: {
    async getSacInfo() {
      let result = await getSacInfo(this.current);
      this.list = result.records.concat(result.records);
      this.recordslength = result.records.length;
      this.changeBScroll();
    },
    initBScroll() {
      return new BScroll('.wrapper', {
        probeType: 3,
        momentum: false,
        bounce: false,
        stopPropagation: true,
        deceleration: 0,
        swipeTime:0,
        swipeBounceTime:0
      });
    },
    changeBScroll() {
      this.$nextTick(() => {
        this.bscroll.refresh();
        this.bscroll.scrollBy(0, this.bscroll.maxScrollY, 1200000);
      });
    }

  },
  beforeDestroy() {
    this.bscroll && this.bscroll.destroy();
  }
};
</script>
<style scoped>
.industrydata{
  margin: 20px 0 43px 0;
  width: 1200px;
  height: 483px;
  overflow: hidden;
}
.industrydata>.industry{
  width: 1200px;
  height: 25px;
  padding: 26px 0 18px;
  background: url(/static/img/img_hangye.png) no-repeat 6px 14px;
  background-size: 41px 41px;
  border-bottom: 4px solid #2479D3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.industrydata>.industry>h3 {
  width: 167px;
  height: 25px;
  padding-left: 58px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 25px;
}
.industrydata>.industry>a {
  width: 32px;
  height: 25px;
  padding: 32px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1759A1;
  line-height: 25px;
  background: url(/static/img/gengduo.png) no-repeat center right;
  background-size: 24px 13px;
}
.tabledata{
  width: 1200px;
  text-align: left;
}
.tabledata>thead>tr>th{
  height: 68px;
  line-height: 68px;
  padding-left: 23px;
  background: #EDEDED;
    height: 19px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #2479D3;
}
.tabledata>tbody{
  border: 1px solid #F5F5F5;
}
.industrydata>.wrapper{
  width: 1198px;
  border: 1px solid #F5F5F5;
  height: 340px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 57px;
  overflow: hidden;
}
.industrydata>.wrapper>.content>ul>li{
  height: 57px;
}
.industrydata>.wrapper>.content>ul>li>span{
  display: inline-block;
  height: 57px;
  overflow: hidden;
}
.industrydata>.wrapper>.content>ul>li>span.size {
  width: 391px;
}
.industrydata>.wrapper>.content>ul>li>span.one {
  width: 208px;
  padding-left: 23px;
}
.industrydata>.wrapper>.content>ul>li>span.last {
  width: 185px;
}
.industrydata>.wrapper>.content>ul>li>span.select {
  width: 391px;
  
  color: #2479D3;
  
}
.industrydata>.wrapper>.content>ul>li:nth-child(2n){
  background: #F7F7F8;
}
</style>
